module.exports = __webpack_public_path__ + "img/laboratorio_4-3_1024.9d18f6fb.webp";